import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'

/* private Customer Types */
import {
  Settings,
  _Customer
} from '../namespace-helper'

import _ from 'lodash'

const selectedUserTemplate = {
  id: 0,
  name: '',
  email: '',
  website: ''
}

export default {
  namespaced: true,
  state: {
    customers: [],
    selectedCustomer: _.cloneDeep(selectedUserTemplate),
    openNewCustomerDialog: false
  },
  mutations: {
    [_Customer.mutations.setCustomers] (state, payload) {
      state.customers = payload
    },
    [_Customer.mutations.setSelectedCustomer] (state, payload) {
      if (payload !== null) {
        state.selectedCustomer = payload
      } else {
        state.selectedCustomer = _.cloneDeep(selectedUserTemplate)
      }
    },
    [_Customer.mutations.setOpenCloseNewCustomerDialogState] (state) {
      state.openNewCustomerDialog = !state.openNewCustomerDialog
    }
  },
  actions: {
    [_Customer.actions.saveCustomers] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)

      if (payload.id === 0) {
        var url = API_URL + '/api/v1/customers'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_Customer.mutations.setSelectedCustomer, r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      } else {
        url = API_URL + '/api/v1/customers/' + payload.id

        axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_Customer.mutations.setSelectedCustomer, r.data.data)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      }
    },
    [_Customer.actions.loadCustomers] (context, payload) {
      console.log('loadCustomers: ' + JSON.stringify(payload))

      var url

      if (typeof payload.limit !== 'undefined') {
        console.log('loadCustomers: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)
        url = API_URL + '/api/v1/customers?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;name:like;email:like;website:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending
      } else {
        console.log('loadCustomers: search')
        url = API_URL + '/api/v1/customers?search=' + payload.search + '&searchFields=id:like;name:like;email:like;website:like'
      }
      /*            if (payload.branch_office_id != null){
                            url += '&branch_office_id=' + payload.branch_office_id
                        } */

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_Customer.mutations.setCustomers, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_Customer.actions.openCloseNewCustomerDialog] ({ commit }) {
      commit(_Customer.mutations.setOpenCloseNewCustomerDialogState)
    },
    [_Customer.actions.setSelectedCustomer] ({ commit }, payload) {
      commit(_Customer.mutations.setSelectedCustomer, payload)
    },
    [_Customer.actions.resetCustomers] ({ commit }, payload) {
      commit(_Customer.mutations.setCustomers, [])
    },
    [_Customer.actions.resetState] ({ commit }, payload) {
      commit(_Customer.mutations.setCustomers, [])
      commit(_Customer.mutations.setSelectedCustomer, null)
    }
  },
  getters: {
    [_Customer.getters.customers] (state) {
      return state.customers
    },
    [_Customer.getters.getOpenNewCustomerDialogState] (state) {
      return state.openNewCustomerDialog
    },
    [_Customer.getters.getSelectedCustomer] (state) {
      return state.selectedCustomer
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/Customer/customers.js